import appGlobalScript from '/Users/louismarcos/Documents/dev/cobalt-designsystem/packages/web-components/src/global/index.ts';
export const globalScripts = appGlobalScript;
